// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__sA3it","content":"Dashboard_content__CJzr0","sidebar":"Dashboard_sidebar__KUmz7","main":"Dashboard_main__wkTpX","top":"Dashboard_top__9FYKU"};